<template>
  <div class="box full">
    <UnificadoFinder
      v-model="showFinder"
      @selected="
        e => {
          newUnificado = e;
          showFinder = false;
        }
      "
    />
    <div class="box-header">
      {{ $t("message.product_variations.title") }}
    </div>
    <div class="box-content-block pt-4">
      <input
        type="text"
        class="regular bordered clear m-2"
        :placeholder="$t('message.product_variations.unificado')"
        :value="unificado"
        disabled
      />
      <input
        type="text"
        class="regular bordered clear m-2"
        :placeholder="$t('message.product_variations.unificado_related')"
        v-model="newUnificado"
        disabled
      />
      <button
        v-if="newUnificado !== '' && userCanEditProducts"
        class="bg-green-success p-2 text-white rounded-md overflow-hidden"
        @click="createVariation"
      >
        {{ $t("message.product_variations.add") }}
      </button>
      <button
        v-if="userCanEditProducts"
        class="p-2 text-blue-700"
        @click="showFinder = true"
      >
        {{ $t("message.product_variations.search") }}
      </button>
    </div>
    <div class="box-content-block pt-4 items-grid">
      <ProductsVariationItem
        v-for="product in products"
        :key="product.nkrCode"
        :product="product"
        @deleteProduct="deleteProduct(product.unificado)"
      />
    </div>
  </div>
</template>
<script>
import {
  getProductsVariations,
  productVariationDelete,
  productVariationInsert
} from "@/api/masterAdmin/ProductVariationsService.js";
import ProductsVariationItem from "./ProductsVariationItem.vue";
import UnificadoFinder from "./UnificadoFinder.vue";
export default {
  name: "ProductsVariationsManager",
  components: {
    ProductsVariationItem,
    UnificadoFinder
  },
  props: {
    unificado: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      products: [],
      showFinder: false,
      newUnificado: ""
    };
  },
  computed: {
    userCanEditProducts() {
      return this.$store.getters["auth/userHasPermission"]("can_edit_products");
    }
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    loadProducts() {
      getProductsVariations(this.unificado).then(res => {
        console.log(res);
        this.products = res;
      });
    },
    deleteProduct(unificado) {
      productVariationDelete(unificado).then(() => {
        this.products = this.products.filter(
          product => product.unificado !== unificado
        );
        this.$toast.open({
          message: `Relation deleted`,
          type: "success",
          position: "top-right"
        });
      });
    },
    createVariation() {
      if (this.unificado === "") return;

      productVariationInsert(this.unificado, this.newUnificado).then(res => {
        if (res.status === "success") {
          this.newUnificado = "";
          this.loadProducts();
          this.$toast.open({
            message: `Relation added`,
            type: "success",
            position: "top-right"
          });
        } else {
          this.$toast.open({
            message: res.message,
            type: "error",
            position: "top-right"
          });
        }
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 10px;
}
</style>
